/** Safe display enums, never upstream messages or provider response bodies. */
export const contactDiagnosticLabels = {
  contact_entries_partial: 'Some contact entries could not be verified. Independently checked entries are shown for review only.',
  contact_sources_partial: 'Some contact sources could not be read. This partial result is not a complete contact inventory.',
  contact_upstream_denied: 'Contact provider denied this read. An administrator must review the connection.',
  contact_upstream_temporary: 'Contact provider temporarily unavailable. Retry this read.',
  contact_upstream_rejected: 'Contact provider rejected the read. Support must review the request reference.',
  contact_source_unavailable: 'Linked-contact source could not be read.',
  contact_read_unavailable: 'Contact read could not be completed.',
  candidate_source_unavailable: 'School coach source could not be read.',
  contact_source_incomplete: 'Contact source returned incomplete information.',
  contact_associations_incomplete: 'Contact associations are incomplete.',
  contact_associations_changed_or_incomplete: 'Contact associations changed or were incomplete. Retry.',
  contact_associations_changed: 'Contact associations changed during the read. Retry.',
  candidate_associations_changed: 'School associations changed during the read. Retry.',
  record_changed_during_read: 'The championship changed during the read. Retry.',
  contact_association_bound: 'This record exceeds the bounded contact read. Support review is required.',
  contact_id_bound: 'This record exceeds the bounded contact read. Support review is required.',
  linked_contact_unavailable: 'A linked contact could not be read.',
  contact_linkage_unverified: 'The contact association could not be verified.',
  no_linked_contacts: 'No direct championship contacts are recorded.',
  no_matching_linked_contacts: 'Linked contacts exist, but none passed current role and sport checks.',
  candidate_source_incomplete: 'School coach information is incomplete.',
  multiple_company_context_required: 'Multiple school associations need review before coaches can be suggested.',
  no_company_association: 'No school association is available for coach matching.',
  winner_context_required: 'A single recorded winning school is needed for school coach matching.',
  winner_company_mismatch: 'The associated school does not exactly match the recorded winner.',
  winner_alias_review_required: 'School-name variation requires human identity review; this is not an approved recipient.',
  winner_school_identity_required: 'A verified school identity is needed before matching coaches.',
  no_matching_associated_coaches: 'No eligible school coaches were returned for this exact school.',
  record_access_restricted: 'This record is restricted in your current scope.',
  record_unavailable: 'The championship could not be read.',
  contact_access_changed: 'Access changed during the read. Refresh your view.',
  unauthorized: 'Sign in to read contacts.', human_required: 'A signed-in person is required for this read.',
  forbidden: 'This contact read is not permitted.',
  contacts_available: 'Contact read complete.',
  contacts_available_with_exclusions: 'Some linked contacts need review and are not listed as usable contacts.',
}
export function safeContactDiagnostic(value) {
  if (!value || !Object.hasOwn(contactDiagnosticLabels, value.code)) return null
  return {code:value.code, retryable:value.retryable === true,
    requestId:typeof value.requestId === 'string' && /^[a-f0-9-]{36}$/i.test(value.requestId) ? value.requestId : ''}
}
export function safeExclusions(value) {
  if (!value || !Number.isSafeInteger(value.total) || value.total < 1) return null
  return {total:value.total}
}
